import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Dialog, Typography } from "@mui/material";
import informationOutlineIcon from "@iconify/icons-mdi/information-outline";
import { InlineIcon } from "@iconify/react";
import { OcTransition } from "oc/components";

type MyHrForgotPasswordDialogSSOProps = {
  showDialog: boolean;
  smallScreen?: boolean;
  onShowDialog: (show: boolean) => void;
};

export const MyHrForgotPasswordDialogSSO = ({
  showDialog,
  smallScreen = false,
  onShowDialog,
}: MyHrForgotPasswordDialogSSOProps) => {
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    onShowDialog(false);
  };

  return (
    <Dialog
      open={showDialog}
      scroll={"body"}
      fullScreen={smallScreen}
      TransitionComponent={OcTransition}
      BackdropProps={{
        style: {
          width: "100%",
          backgroundImage: "url(/img/loginBg.jpg)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        height="inherit"
      >
        <Box width={smallScreen ? "auto" : "400px"} padding="24px">
          <Box textAlign="center" p={0} marginTop="14px">
            <InlineIcon
              icon={informationOutlineIcon}
              width="64px"
              height="64px"
              color="#5E6366"
            />
          </Box>
          <Box textAlign="center" marginTop="30px">
            <Typography variant="h6">
              {t("MY_HR_TITLE_FORGOT_PASSWORD_IS_NOT_AVAILABLE")}
            </Typography>
            <Box
              height="88px"
              marginTop="26px"
              marginBottom="16px"
              style={{ textAlign: "left" }}
            >
              <Typography>
                {t("MY_HR_TEXT_FORGOT_PASSWORD_IS_NOT_AVAILABLE")}
              </Typography>
            </Box>
          </Box>
          <Box textAlign="center" paddingTop="26px" paddingBottom="6px">
            <Box
              onClick={handleCloseDialog}
              style={{
                textDecoration: "none",
                fontSize: 16,
                letterSpacing: 0.44,
                color: "#CC0033",
                cursor: "pointer",
              }}
            >
              {t("MY_HR_LINK_BACK_TO_LOGIN")}
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MyHrForgotPasswordDialogSSO;
